import Query from 'library/util/query';
import { jsonToInputParams } from 'library/util/graph';

const CreateSurveyMutation = async (user_uuid, answered_questions=[]) => (
  await Query(`
    mutation {
      create_career_cluster_survey(${jsonToInputParams({user_uuid, answered_questions})}) {
        success
        survey {
          id
          category {
            id
          }
          response_store {
           answered_questions
         }
        }
      }
    }
  `)
);

export default CreateSurveyMutation;
